export const DETALHE_HISTORICO_ALTERACAO_PJ= [
  {
    "indicadorMudanca": "DPV",
    "dataEvento": [
      1997,
      1,
      1
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0521334",
    "horaProcessamento": "0521334",
    "dataProcessamento": [
      2014,
      5,
      13
    ],
    "dataDigitacao": [
      2014,
      5,
      13
    ],
    "terminal": "COCAD 143/13",
    "alteracao": ""
  },
  {
    "indicadorMudanca": "NIRE",
    "dataEvento": [
      2011,
      2,
      18
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0123645",
    "horaProcessamento": "0123645",
    "dataProcessamento": [
      2012,
      8,
      27
    ],
    "dataDigitacao": [
      2012,
      8,
      27
    ],
    "terminal": "COCAD 0096/2009",
    "alteracao": "35214587583"
  },
  {
    "indicadorMudanca": "NIRE",
    "dataEvento": [
      2011,
      2,
      18
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0211853",
    "horaProcessamento": "0211853",
    "dataProcessamento": [
      2012,
      8,
      27
    ],
    "dataDigitacao": [
      2012,
      8,
      27
    ],
    "terminal": "COCAD 0096/2009",
    "alteracao": "35214587583"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2010,
      10,
      19
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": null,
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0163313",
    "horaProcessamento": "1827402",
    "dataProcessamento": [
      2010,
      10,
      22
    ],
    "dataDigitacao": [
      2010,
      10,
      7
    ],
    "terminal": "DEF. AUTOMATICO",
    "alteracao": "SUSPENSA DEF. RFB AG. AN. DO CONVENENTE"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2005,
      8,
      27
    ],
    "cpfConferente": "15216904808",
    "cpfDigitador": "15216904808",
    "cpfTransmissor": "15216904808",
    "horaDigitacao": "0120506",
    "horaProcessamento": "1205161",
    "dataProcessamento": [
      2010,
      10,
      19
    ],
    "dataDigitacao": [
      2010,
      10,
      19
    ],
    "terminal": "010.058.188.046",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2010,
      10,
      19
    ],
    "cpfConferente": "15216904808",
    "cpfDigitador": null,
    "cpfTransmissor": "15216904808",
    "horaDigitacao": "0163313",
    "horaProcessamento": "1205472",
    "dataProcessamento": [
      2010,
      10,
      19
    ],
    "dataDigitacao": [
      2010,
      10,
      7
    ],
    "terminal": "010.058.188.046",
    "alteracao": "SUSPENSA BAIXA INIC AINDA NAO DEFERIDA"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": [
      2003,
      3,
      12
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": null,
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0120047",
    "horaProcessamento": "1641237",
    "dataProcessamento": [
      2010,
      3,
      25
    ],
    "dataDigitacao": [
      2010,
      3,
      15
    ],
    "terminal": "DEF. AUTOMATICO",
    "alteracao": "NGAGH NH KWTQWU 2422 JARDIM SANTA LUCIA"
  },
  {
    "indicadorMudanca": "ENDP",
    "dataEvento": [
      2003,
      3,
      12
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": null,
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0120047",
    "horaProcessamento": "1641237",
    "dataProcessamento": [
      2010,
      3,
      25
    ],
    "dataDigitacao": [
      2010,
      3,
      15
    ],
    "terminal": "DEF. AUTOMATICO",
    "alteracao": "11 45968227 11 46061558 ALESSANDRA.SCHNEIDER@CONTI.COM.BR"
  },
  {
    "indicadorMudanca": "MAT",
    "dataEvento": null,
    "cpfConferente": "00041868854",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0101436",
    "horaProcessamento": "1504288",
    "dataProcessamento": [
      2010,
      3,
      10
    ],
    "dataDigitacao": [
      2010,
      3,
      1
    ],
    "terminal": "010.058.188.217",
    "alteracao": "02036483000100"
  },
  {
    "indicadorMudanca": "CPF",
    "dataEvento": [
      2006,
      3,
      31
    ],
    "cpfConferente": "00041868854",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0162146",
    "horaProcessamento": "1608365",
    "dataProcessamento": [
      2008,
      5,
      19
    ],
    "dataDigitacao": [
      2008,
      5,
      5
    ],
    "terminal": "010.058.188.032",
    "alteracao": "213685718"
  },
  {
    "indicadorMudanca": "ATV",
    "dataEvento": [
      2003,
      3,
      12
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0151405",
    "horaProcessamento": "0151405",
    "dataProcessamento": [
      2006,
      12,
      29
    ],
    "dataDigitacao": [
      2006,
      12,
      29
    ],
    "terminal": "CORAT 582/2006",
    "alteracao": "3443 - NAO ESPECIFICADA"
  },
  {
    "indicadorMudanca": "CPF",
    "dataEvento": [
      2000,
      11,
      30
    ],
    "cpfConferente": "00041868854",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0153508",
    "horaProcessamento": "1533313",
    "dataProcessamento": [
      2006,
      9,
      12
    ],
    "dataDigitacao": [
      2006,
      9,
      4
    ],
    "terminal": "010.058.188.032",
    "alteracao": "070204908"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2005,
      8,
      6
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0020127",
    "horaProcessamento": "0020127",
    "dataProcessamento": [
      2005,
      8,
      27
    ],
    "dataDigitacao": [
      2005,
      8,
      27
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2005,
      4,
      23
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0114525",
    "horaProcessamento": "0114525",
    "dataProcessamento": [
      2005,
      8,
      6
    ],
    "dataDigitacao": [
      2005,
      8,
      6
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2005,
      1,
      15
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0030804",
    "horaProcessamento": "0030804",
    "dataProcessamento": [
      2005,
      4,
      23
    ],
    "dataDigitacao": [
      2005,
      4,
      23
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2004,
      12,
      18
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0003538",
    "horaProcessamento": "0003538",
    "dataProcessamento": [
      2005,
      1,
      15
    ],
    "dataDigitacao": [
      2005,
      1,
      15
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR REST.CERT.POSIT.EFEIT.NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2004,
      11,
      20
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0084635",
    "horaProcessamento": "0084635",
    "dataProcessamento": [
      2004,
      12,
      18
    ],
    "dataDigitacao": [
      2004,
      12,
      18
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2004,
      10,
      23
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0013148",
    "horaProcessamento": "0013148",
    "dataProcessamento": [
      2004,
      11,
      20
    ],
    "dataDigitacao": [
      2004,
      11,
      20
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR REST.CERT.POSIT.EFEIT.NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2004,
      9,
      11
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0093015",
    "horaProcessamento": "0093015",
    "dataProcessamento": [
      2004,
      10,
      23
    ],
    "dataDigitacao": [
      2004,
      10,
      23
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2004,
      7,
      17
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0084045",
    "horaProcessamento": "0084045",
    "dataProcessamento": [
      2004,
      9,
      11
    ],
    "dataDigitacao": [
      2004,
      9,
      11
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR REST.CERT.POSIT.EFEIT.NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2004,
      6,
      5
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0085547",
    "horaProcessamento": "0085547",
    "dataProcessamento": [
      2004,
      7,
      17
    ],
    "dataDigitacao": [
      2004,
      7,
      17
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2002,
      3,
      2
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0005013",
    "horaProcessamento": "0005013",
    "dataProcessamento": [
      2004,
      6,
      5
    ],
    "dataDigitacao": [
      2004,
      6,
      5
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR REST.CERT.POSIT.EFEIT.NEGATIVA"
  },
  {
    "indicadorMudanca": "NF",
    "dataEvento": null,
    "cpfConferente": "12069548848",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "horaDigitacao": "0093708",
    "horaProcessamento": "0847350",
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "terminal": "010.203.192.024",
    "alteracao": "KXMVQMHMVWD NX OIWUQD"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": [
      2002,
      8,
      14
    ],
    "cpfConferente": "12069548848",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "horaDigitacao": "0093708",
    "horaProcessamento": "0847350",
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "terminal": "010.203.192.024",
    "alteracao": "WEHMQNW MXEH NH RGDCX 2960 JARDIM ANHANGUERA"
  },
  {
    "indicadorMudanca": "ENDP",
    "dataEvento": [
      2000,
      11,
      30
    ],
    "cpfConferente": "12069548848",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "horaDigitacao": "0093708",
    "horaProcessamento": "0847350",
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "terminal": "010.203.192.024",
    "alteracao": "0011 45836161 0011 45836164 conti@conti.com.br"
  },
  {
    "indicadorMudanca": "ATV",
    "dataEvento": [
      1999,
      5,
      25
    ],
    "cpfConferente": "12069548848",
    "cpfDigitador": null,
    "cpfTransmissor": "12069548848",
    "horaDigitacao": "0093708",
    "horaProcessamento": "0847350",
    "dataProcessamento": [
      2003,
      4,
      7
    ],
    "dataDigitacao": [
      2003,
      4,
      4
    ],
    "terminal": "010.203.192.024",
    "alteracao": "5030001 - NAO ESPECIFICADA"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": [
      2000,
      11,
      30
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0230016",
    "horaProcessamento": "2300167",
    "dataProcessamento": [
      2002,
      8,
      14
    ],
    "dataDigitacao": [
      2002,
      8,
      14
    ],
    "terminal": "DEMANDA 169/02",
    "alteracao": "WEHMQNW MXEH NH RGDCX 2960 JARDIM ANHANGUERA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2002,
      1,
      26
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0102416",
    "horaProcessamento": "0102416",
    "dataProcessamento": [
      2002,
      3,
      2
    ],
    "dataDigitacao": [
      2002,
      3,
      2
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2001,
      12,
      29
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0103229",
    "horaProcessamento": "0103229",
    "dataProcessamento": [
      2002,
      1,
      26
    ],
    "dataDigitacao": [
      2002,
      1,
      26
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2001,
      5,
      6
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0120938",
    "horaProcessamento": "0120938",
    "dataProcessamento": [
      2001,
      12,
      29
    ],
    "dataDigitacao": [
      2001,
      12,
      29
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2001,
      4,
      10
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0065915",
    "horaProcessamento": "0065915",
    "dataProcessamento": [
      2001,
      5,
      6
    ],
    "dataDigitacao": [
      2001,
      5,
      6
    ],
    "terminal": "BATIMENTOREGFIS",
    "alteracao": "ATIVA NAO REGULAR CERT. POSITIVA EFEITO NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2000,
      12,
      2
    ],
    "cpfConferente": "00041868854",
    "cpfDigitador": "00041868854",
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0110332",
    "horaProcessamento": "1103321",
    "dataProcessamento": [
      2001,
      4,
      10
    ],
    "dataDigitacao": [
      2001,
      4,
      10
    ],
    "terminal": "N03218CE",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": [
      1999,
      8,
      13
    ],
    "cpfConferente": "86764012849",
    "cpfDigitador": null,
    "cpfTransmissor": "86764012849",
    "horaDigitacao": "0081441",
    "horaProcessamento": "1615364",
    "dataProcessamento": [
      2000,
      12,
      19
    ],
    "dataDigitacao": [
      2000,
      12,
      19
    ],
    "terminal": "0037108",
    "alteracao": "WE. MXEH NH RGDCX 2101 LOJA 1 JARDIM ANHAGUERA"
  },
  {
    "indicadorMudanca": "ENDP",
    "dataEvento": [
      1999,
      8,
      13
    ],
    "cpfConferente": "86764012849",
    "cpfDigitador": null,
    "cpfTransmissor": "86764012849",
    "horaDigitacao": "0081441",
    "horaProcessamento": "1615364",
    "dataProcessamento": [
      2000,
      12,
      19
    ],
    "dataDigitacao": [
      2000,
      12,
      19
    ],
    "terminal": "0037108",
    "alteracao": "000000 0011 73936161 011 7936164 CONTI@CONTI.COM.BR"
  },
  {
    "indicadorMudanca": "CPF",
    "dataEvento": [
      1999,
      2,
      8
    ],
    "cpfConferente": "86764012849",
    "cpfDigitador": null,
    "cpfTransmissor": "86764012849",
    "horaDigitacao": "0081441",
    "horaProcessamento": "1615364",
    "dataProcessamento": [
      2000,
      12,
      19
    ],
    "dataDigitacao": [
      2000,
      12,
      19
    ],
    "terminal": "0037108",
    "alteracao": "215746248"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": [
      1999,
      5,
      25
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0023212",
    "horaProcessamento": "0232123",
    "dataProcessamento": [
      2000,
      12,
      14
    ],
    "dataDigitacao": [
      2000,
      12,
      14
    ],
    "terminal": "N03218RO",
    "alteracao": "WEHMQNW MXEH NH RGDCX 2101 LOJA 1 JARDIM ANHAGUERA"
  },
  {
    "indicadorMudanca": "ENDP",
    "dataEvento": [
      1999,
      5,
      25
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0023212",
    "horaProcessamento": "0232123",
    "dataProcessamento": [
      2000,
      12,
      14
    ],
    "dataDigitacao": [
      2000,
      12,
      14
    ],
    "terminal": "N03218RO",
    "alteracao": "000000 011 7936167 011 7936164"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2000,
      10,
      10
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0193244",
    "horaProcessamento": "0193244",
    "dataProcessamento": [
      2000,
      12,
      2
    ],
    "dataDigitacao": [
      2000,
      12,
      2
    ],
    "terminal": "BATIMENT",
    "alteracao": "ATIVA NAO REGULAR CERT. POSITIVA EFEITO NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2000,
      6,
      3
    ],
    "cpfConferente": "39310345853",
    "cpfDigitador": "39310345853",
    "cpfTransmissor": "39310345853",
    "horaDigitacao": "0141110",
    "horaProcessamento": "1411101",
    "dataProcessamento": [
      2000,
      10,
      10
    ],
    "dataDigitacao": [
      2000,
      10,
      10
    ],
    "terminal": "N03218CE",
    "alteracao": "ATIVA NAO REGULAR IRREGULARIDADE DE PAGAMENTO"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      2000,
      4,
      10
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0110248",
    "horaProcessamento": "0110248",
    "dataProcessamento": [
      2000,
      6,
      3
    ],
    "dataDigitacao": [
      2000,
      6,
      3
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA NAO REGULAR CERT. POSITIVA EFEITO NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1999,
      12,
      4
    ],
    "cpfConferente": "39310345853",
    "cpfDigitador": "39310345853",
    "cpfTransmissor": "39310345853",
    "horaDigitacao": "0110023",
    "horaProcessamento": "1100239",
    "dataProcessamento": [
      2000,
      4,
      10
    ],
    "dataDigitacao": [
      2000,
      4,
      10
    ],
    "terminal": "N03218CE",
    "alteracao": "ATIVA NAO REGULAR IRREGULARIDADE DE PAGAMENTO"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1999,
      10,
      14
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0104319",
    "horaProcessamento": "0104319",
    "dataProcessamento": [
      1999,
      12,
      4
    ],
    "dataDigitacao": [
      1999,
      12,
      4
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA NAO REGULAR CERT. POSITIVA EFEITO NEGATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1999,
      9,
      25
    ],
    "cpfConferente": "39310345853",
    "cpfDigitador": "39310345853",
    "cpfTransmissor": "39310345853",
    "horaDigitacao": "0085848",
    "horaProcessamento": "0858480",
    "dataProcessamento": [
      1999,
      10,
      14
    ],
    "dataDigitacao": [
      1999,
      10,
      14
    ],
    "terminal": "N03218CE",
    "alteracao": "ATIVA NAO REGULAR IRREGULARIDADE DE PAGAMENTO"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1999,
      9,
      11
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0095511",
    "horaProcessamento": "0955119",
    "dataProcessamento": [
      1999,
      9,
      25
    ],
    "dataDigitacao": [
      1999,
      9,
      25
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1999,
      9,
      4
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0141259",
    "horaProcessamento": "1412595",
    "dataProcessamento": [
      1999,
      9,
      11
    ],
    "dataDigitacao": [
      1999,
      9,
      11
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA NAO REGULAR IRREGULARIDADE DE PAGAMENTO"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1998,
      7,
      28
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0120501",
    "horaProcessamento": "1205013",
    "dataProcessamento": [
      1999,
      9,
      4
    ],
    "dataDigitacao": [
      1999,
      9,
      4
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": [
      1998,
      7,
      17
    ],
    "cpfConferente": "00041868854",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0150005",
    "horaProcessamento": "1538433",
    "dataProcessamento": [
      1999,
      6,
      17
    ],
    "dataDigitacao": [
      1999,
      6,
      11
    ],
    "terminal": "0065298",
    "alteracao": "IGW QBGWVHPQ 354 CONJUNTOS 102 E 112 ITAIM"
  },
  {
    "indicadorMudanca": "ENDP",
    "dataEvento": [
      1998,
      7,
      17
    ],
    "cpfConferente": "00041868854",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0150005",
    "horaProcessamento": "1538433",
    "dataProcessamento": [
      1999,
      6,
      17
    ],
    "dataDigitacao": [
      1999,
      6,
      11
    ],
    "terminal": "0065298",
    "alteracao": "0011 8167399 0011 2115008"
  },
  {
    "indicadorMudanca": "ATV",
    "dataEvento": [
      1999,
      2,
      8
    ],
    "cpfConferente": "00041868854",
    "cpfDigitador": null,
    "cpfTransmissor": "00041868854",
    "horaDigitacao": "0150005",
    "horaProcessamento": "1538433",
    "dataProcessamento": [
      1999,
      6,
      17
    ],
    "dataDigitacao": [
      1999,
      6,
      11
    ],
    "terminal": "0065298",
    "alteracao": "3443 - NAO ESPECIFICADA"
  },
  {
    "indicadorMudanca": "ATV",
    "dataEvento": null,
    "cpfConferente": "06579709804",
    "cpfDigitador": null,
    "cpfTransmissor": "11648048803",
    "horaDigitacao": "0062300",
    "horaProcessamento": "1017250",
    "dataProcessamento": [
      1999,
      4,
      16
    ],
    "dataDigitacao": [
      1999,
      4,
      15
    ],
    "terminal": "0019328",
    "alteracao": "2511 - NAO ESPECIFICADA"
  },
  {
    "indicadorMudanca": "CPF",
    "dataEvento": [
      1998,
      6,
      9
    ],
    "cpfConferente": "07313392826",
    "cpfDigitador": null,
    "cpfTransmissor": "16292290832",
    "horaDigitacao": "0153320",
    "horaProcessamento": "1421233",
    "dataProcessamento": [
      1999,
      4,
      9
    ],
    "dataDigitacao": [
      1999,
      4,
      8
    ],
    "terminal": "0040775",
    "alteracao": "777674895"
  },
  {
    "indicadorMudanca": "END",
    "dataEvento": null,
    "cpfConferente": "01685862829",
    "cpfDigitador": null,
    "cpfTransmissor": "01685862829",
    "horaDigitacao": "0102322",
    "horaProcessamento": "1223337",
    "dataProcessamento": [
      1998,
      9,
      10
    ],
    "dataDigitacao": [
      1998,
      9,
      4
    ],
    "terminal": "0011571",
    "alteracao": "I RHIXMQPX NW EHQBW 164 CJTOS 6B E 6D ITAIM"
  },
  {
    "indicadorMudanca": "ENDP",
    "dataEvento": null,
    "cpfConferente": "01685862829",
    "cpfDigitador": null,
    "cpfTransmissor": "01685862829",
    "horaDigitacao": "0102322",
    "horaProcessamento": "1223337",
    "dataProcessamento": [
      1998,
      9,
      10
    ],
    "dataDigitacao": [
      1998,
      9,
      4
    ],
    "terminal": "0011571",
    "alteracao": ""
  },
  {
    "indicadorMudanca": "CPF",
    "dataEvento": null,
    "cpfConferente": "01685862829",
    "cpfDigitador": null,
    "cpfTransmissor": "01685862829",
    "horaDigitacao": "0102322",
    "horaProcessamento": "1223337",
    "dataProcessamento": [
      1998,
      9,
      10
    ],
    "dataDigitacao": [
      1998,
      9,
      4
    ],
    "terminal": "0011571",
    "alteracao": "516531098"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1998,
      5,
      30
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0010656",
    "horaProcessamento": "0106567",
    "dataProcessamento": [
      1998,
      7,
      29
    ],
    "dataDigitacao": [
      1998,
      7,
      29
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA NAO REGULAR COM PENDENCIA FISCAL"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": [
      1998,
      1,
      17
    ],
    "cpfConferente": "00000000191",
    "cpfDigitador": "00000000191",
    "cpfTransmissor": "00000000191",
    "horaDigitacao": "0063740",
    "horaProcessamento": "0637401",
    "dataProcessamento": [
      1998,
      5,
      31
    ],
    "dataDigitacao": [
      1998,
      5,
      31
    ],
    "terminal": "CERTIDAO",
    "alteracao": "ATIVA"
  },
  {
    "indicadorMudanca": "SIT",
    "dataEvento": null,
    "cpfConferente": "69677298100",
    "cpfDigitador": "69677298100",
    "cpfTransmissor": "69677298100",
    "horaDigitacao": "0213255",
    "horaProcessamento": "2132557",
    "dataProcessamento": [
      1998,
      1,
      17
    ],
    "dataDigitacao": [
      1998,
      1,
      17
    ],
    "terminal": "DICOR-AP",
    "alteracao": "ATIVA"
  }
]